import $ from "jquery";

const applycoupon = () => {
  const init = () => {
    cartCoupon();
    CheckoutCoupon();
  };

  const cartCoupon = () => {
    const el = {
      input: "#js-apply-coupon",
      codecupon: "#coupon_code",
      btnSubmit: ".woocommerce-cart-form button[name='apply_coupon']",
    };

    if ($(el.input).length === 0) return;

    $(document).on("input", el.input, function (e) {
      e.preventDefault();

      $(el.codecupon).val($(this).val());
    });

    $(document).on("blur", el.input, function () {
      if ($(this).val() == "") return;
      $(el.btnSubmit).trigger("click");
    });
  };

  const CheckoutCoupon = () => {
    const el = {
      // anchorTop: "#anchor_top",
      anchorTop: ".elementor-section:first",
      input: "#js-checkout-apply-coupon",
      codecupon: "#coupon_code",
      btnSubmit: ".woocommerce-form-coupon button[name='apply_coupon']",
      btnSubmitTrigger: ".js-coupoun-trigger",
    };

    if ($(el.input).length === 0) return;

    $(document).on("input", el.input, function (e) {
      e.preventDefault();

      $(el.codecupon).val($(this).val());
    });

    // eslint-disable-next-line no-unused-vars
    $(document).on("click", el.btnSubmitTrigger, function (e) {
      // e.preventDefault();

      if ($("el.input").val() == "") return;
      $(el.btnSubmit).trigger("click");
      // $(this).val("");
      $(el.anchorTop)[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });

    // $(document).on("blur", el.input, function () {
    //   if ($(this).val() == "") return;
    //   $(el.btnSubmit).trigger("click");
    //   $(this).val("");
    //   $(el.anchorTop)[0].scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //     inline: "nearest",
    //   });
    // });
  };

  init();
};

try {
  applycoupon();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
